import SellsukiProvider from '@/resources/sellsuki_provider'
const sellsukiProvider = new SellsukiProvider()

const state = {
  sellsukiData: {},
  branch: [],
  initailData: {},
  paymentChannel: [],
  billExpire: 1
}

const actions = {
  setSellsukiAuth ({commit}, payload) {
    commit('SET_AUTH_SELLSUKI', payload)
  },
  async fetchBranch ({commit}) {
    const results = await sellsukiProvider.fetchBranch()
    commit('SET_BRANCH', results)
  },
  async init ({ commit }) {
    const { billExpire, paymentChannel, initData } = await sellsukiProvider.getPaymentChannelId()
    commit('SET_INITAIL_DATA', initData)
    commit('SET_PAYMENT_CHANNEL', paymentChannel)
    commit('SET_BILL_EXPIRE', billExpire)
    return { initData }
  }
}

const mutations = {
  SET_AUTH_SELLSUKI: (state, payload) => {
    state.sellsukiData = payload
  },
  SET_BRANCH: (state, payload) => {
    state.branch = payload
  },
  SET_INITAIL_DATA: (state, payload) => {
    state.initailData = payload
  },
  SET_PAYMENT_CHANNEL: (state, payload) => {
    state.paymentChannel = payload
  },
  SET_BILL_EXPIRE: (state, payload) => {
    state.billExpire = payload
  }
}

const getters = {
  getSellsukiAuth: state => state.sellsukiData,
  getBranch: state => state.branch,
  storeId: state => state.initailData.store.id,
  initailData: state => state.initailData,
  paymentChannel: state => state.paymentChannel,
  billExpire: state => state.billExpire
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sellsukiData.js